import reddit from 'images/icon-reddit.svg'
import twitter from 'images/icon-twitter.svg'

import g2Icon from 'images/g2-icon.jpeg'

import pulkit from 'pages/home/components/swiper-component/assets/avatars/pulkit.png'

import redditVip from './images/reddit-vip.svg'
import twitterVip from './images/twitter-vip.svg'

import gokuafrica from './avatars/gokuafrica.png'
import titan from './avatars/titan.png'
import valerios from './avatars/valerios-baglaridis.png'
import reuben from './avatars/reuben-firo.png'
import vik from './avatars/vik-cake.png'
import sahad from './avatars/sahad.png'

const imageSizes = {
  twitter: 69,
  trustpilot: 120,
  reddit: 147,
  g2: 50,
}

export const slides = [
  {
    id: 1,
    link:
      'https://www.reddit.com/r/Monero/comments/ooqc4p/borrowing_xmr_at_coinrabbit/h6z923w/?utm_source=reddit&utm_medium=web2x&context=3',
    author: {
      name: 'Vik Sharma',
      position: 'Cake Wallet CEO',
      avatar: vik,
      avatarAlt: 'Crypto loans review 1',
    },
    image: reddit,
    imageWidth: imageSizes.reddit,
    title: <>Reliable, safe and fast Crypto loans</>,
    text: (
      <>
        I&apos;ve used CoinRabbit multiple times and found their service to be reliable, safe, and fast. The customer
        service has been spectacular as well. I would recommend this to anyone who wants a loan against their crypto.
      </>
    ),
  },
  {
    id: 2,
    link: 'https://www.g2.com/products/coinrabbit/reviews',
    author: {
      name: 'Andrew S.',
      avatar: titan,
      avatarAlt: 'Crypto loans review 2',
    },
    isWidget: true,
    image: <img src={g2Icon} style={{ width: '50px', height: '50px' }} alt={'G2'}></img>,
    imageAlt: 'Crypto loans review 7',
    title: <>Most Reliable Crypto Collateral Loan System There is</>,
    text: <>Very reasonable APR rates and no credit checks makes for an easy user experience.</>,
  },
  {
    id: 3,
    link: 'https://twitter.com/walerikus/status/1420427814000644099?s=21',
    author: {
      name: 'Valerios Baglaridis',
      position: 'DGB Influencer',
      avatar: valerios,
      avatarAlt: 'Crypto loans review 3',
    },
    image: twitter,
    imageWidth: imageSizes.twitter,
    title: <>By far the best user experience provided by CoinRabbit</>,
    text: (
      <>
        CoinRabbit provides by far the best user experience, and I have tried nexo finances, celsius and various
        ethereum based defi protocols like MakerDAO and compound finance.
      </>
    ),
  },
  {
    id: 4,
    link: 'https://www.g2.com/products/coinrabbit/reviews',
    author: {
      name: 'Sahad N.',
      avatar: sahad,
      avatarAlt: 'Crypto loans review 4',
    },
    image: <img src={g2Icon} style={{ width: '50px', height: '50px' }} alt={'G2'}></img>,
    isWidget: true,
    imageAlt: 'Crypto loans review 8',
    title: <>Hassle free crypto loan in few steps</>,
    text: (
      <>
        Simple, prompt delivery of loans without any trouble. The interface is very easy to use and gets things done. I
        {"'"}am a regular visitor to the website whenever I am in need. Purely trustable source of money.
      </>
    ),
  },
  {
    id: 5,
    link: 'https://twitter.com/firoorg/status/1403350419279998981?s=21',
    author: {
      name: 'Reuben',
      position: 'FIRO cofounder',
      avatar: reuben,
      avatarAlt: 'Crypto loans review 5',
    },
    image: twitter,
    imageWidth: imageSizes.twitter,
    title: <>Seamless and quick FIRO loans without registration</>,
    text: (
      <>
        Getting a stablecoin loan on CoinRabbit using FIRO is seamless and quick without requiring user registration.
        Its flexibility in having loans with no fixed duration are also very attractive allowing you to hodl your crypto
        while having USD to spend.
      </>
    ),
  },
  {
    id: 6,
    link: 'https://twitter.com/gokuafrica/status/1421938014897410048?s=21',
    author: {
      name: '@Gokuafrika',
      avatar: gokuafrica,
      avatarAlt: 'Crypto loans review 6',
    },
    image: twitter,
    imageWidth: imageSizes.twitter,
    title: <>Friendly loan terms: choose when to make payments yourself</>,
    text: (
      <>
        I am still riding the wave. Too early to make any profits off my loans. The cool thing is that by putting crypto
        as collateral and using your friendly loan terms, I can choose when to make payments to close/partially close
        loans. This is awesome as this frees me a lot!
      </>
    ),
  },
]

export const slidesVip = [
  {
    id: 1,
    link:
      'https://www.reddit.com/r/Monero/comments/ooqc4p/borrowing_xmr_at_coinrabbit/h6z923w/?utm_source=reddit&utm_medium=web2x&context=3',
    author: {
      name: 'Vik Sharma',
      position: 'Cake Wallet CEO',
      avatar: vik,
      avatarAlt: 'Crypto loans review 1',
    },
    image: redditVip,
    imageWidth: imageSizes.reddit,
    title: <>Reliable, safe and fast Crypto loans</>,
    text: (
      <>
        I&apos;ve used CoinRabbit multiple times and found their service to be reliable, safe, and fast. The customer
        service has been spectacular as well. I would recommend this to anyone who wants a loan against their crypto.
      </>
    ),
  },
  {
    id: 2,
    link: 'https://www.g2.com/products/coinrabbit/reviews',
    author: {
      name: 'Andrew S.',
      avatar: titan,
      avatarAlt: 'Crypto loans review 2',
    },
    isWidget: true,
    image: <img src={g2Icon} style={{ width: '50px', height: '50px' }} alt={'G2'}></img>,
    imageAlt: 'Crypto loans review 7',
    title: <>Most Reliable Crypto Collateral Loan System There is</>,
    text: <>Very reasonable APR rates and no credit checks makes for an easy user experience.</>,
  },
  {
    id: 3,
    link: 'https://twitter.com/walerikus/status/1420427814000644099?s=21',
    author: {
      name: 'Valerios Baglaridis',
      position: 'DGB Influencer',
      avatar: valerios,
      avatarAlt: 'Crypto loans review 3',
    },
    image: twitterVip,
    imageWidth: imageSizes.twitter,
    title: <>By far the best user experience provided by CoinRabbit</>,
    text: (
      <>
        CoinRabbit provides by far the best user experience, and I have tried nexo finances, celsius and various
        ethereum based defi protocols like MakerDAO and compound finance.
      </>
    ),
  },
  {
    id: 4,
    link: 'https://www.g2.com/products/coinrabbit/reviews',
    author: {
      name: 'Sahad N.',
      avatar: sahad,
      avatarAlt: 'Crypto loans review 4',
    },
    image: <img src={g2Icon} style={{ width: '50px', height: '50px' }} alt={'G2'}></img>,
    isWidget: true,
    imageAlt: 'Crypto loans review 8',
    title: <>Hassle free crypto loan in few steps</>,
    text: (
      <>
        Simple, prompt delivery of loans without any trouble. The interface is very easy to use and gets things done. I
        {"'"}am a regular visitor to the website whenever I am in need. Purely trustable source of money.
      </>
    ),
  },
  {
    id: 5,
    link: 'https://twitter.com/firoorg/status/1403350419279998981?s=21',
    author: {
      name: 'Reuben',
      position: 'FIRO cofounder',
      avatar: reuben,
      avatarAlt: 'Crypto loans review 5',
    },
    image: twitterVip,
    imageWidth: imageSizes.twitter,
    title: <>Seamless and quick FIRO loans without registration</>,
    text: (
      <>
        Getting a stablecoin loan on CoinRabbit using FIRO is seamless and quick without requiring user registration.
        Its flexibility in having loans with no fixed duration are also very attractive allowing you to hodl your crypto
        while having USD to spend.
      </>
    ),
  },
  {
    id: 6,
    link: 'https://twitter.com/gokuafrica/status/1421938014897410048?s=21',
    author: {
      name: '@Gokuafrika',
      avatar: gokuafrica,
      avatarAlt: 'Crypto loans review 6',
    },
    image: twitterVip,
    imageWidth: imageSizes.twitter,
    title: <>Friendly loan terms: choose when to make payments yourself</>,
    text: (
      <>
        I am still riding the wave. Too early to make any profits off my loans. The cool thing is that by putting crypto
        as collateral and using your friendly loan terms, I can choose when to make payments to close/partially close
        loans. This is awesome as this frees me a lot!
      </>
    ),
  },
]

export const exchangeSlides = [
  {
    id: 1,
    link:
      'https://www.reddit.com/r/Monero/comments/ooqc4p/borrowing_xmr_at_coinrabbit/h6z923w/?utm_source=reddit&utm_medium=web2x&context=3',
    author: {
      name: 'Vik Sharma',
      position: 'Cake Wallet CEO',
      avatar: vik,
      avatarAlt: 'Crypto loans review 1',
    },
    image: reddit,
    title: <>Reliable, safe and fast Crypto loans</>,
    text: (
      <>
        I&apos;ve used CoinRabbit multiple times and found their service to be reliable, safe, and fast. The customer
        service has been spectacular as well. I would recommend this to anyone who wants a loan against their crypto.
      </>
    ),
  },
  {
    id: 2,
    link: 'https://www.g2.com/products/coinrabbit/reviews',
    author: {
      name: 'Pedro J.',
      avatar: titan,
      avatarAlt: 'Crypto loans review 2',
    },
    isWidget: true,
    image: <img src={g2Icon} style={{ width: '50px', height: '50px' }} alt={'G2'}></img>,
    imageAlt: 'Crypto loans review 7',
    title: <>Crypto Review</>,
    text: <>Find it nice to have all the crypto currencies available for use</>,
  },
  {
    id: 3,
    link: 'https://twitter.com/walerikus/status/1420427814000644099?s=21',
    author: {
      name: 'Valerios Baglaridis',
      position: 'DGB Influencer',
      avatar: valerios,
      avatarAlt: 'Crypto loans review 3',
    },
    image: twitter,
    title: <>By far the best user experience provided by CoinRabbit</>,
    text: (
      <>
        CoinRabbit provides by far the best user experience, and I have tried nexo finances, celsius and various
        ethereum based defi protocols like MakerDAO and compound finance.
      </>
    ),
  },
  {
    id: 4,
    link: 'https://www.g2.com/products/coinrabbit/reviews',
    author: {
      name: 'Pulkit D.',
      avatar: pulkit,
      avatarAlt: 'Crypto loans review 4',
    },
    image: <img src={g2Icon} style={{ width: '50px', height: '50px' }} alt={'G2'}></img>,
    isWidget: true,
    imageAlt: 'Crypto loans review 8',
    title: <>I totally admire their support team</>,
    text: (
      <>
        I totally admire their support team, they provide the quickest replies and resolutions even at the peak hour.
        The verification procedure is very simple. Time issues are not present while borrowing or selling.
      </>
    ),
  },
  {
    id: 5,
    link: 'https://twitter.com/firoorg/status/1403350419279998981?s=21',
    author: {
      name: 'Reuben',
      position: 'FIRO cofounder',
      avatar: reuben,
      avatarAlt: 'Crypto loans review 5',
    },
    image: twitter,
    title: <>Seamless and quick FIRO loans without registration</>,
    text: (
      <>
        Getting a stablecoin loan on CoinRabbit using FIRO is seamless and quick without requiring user registration.
        Its flexibility in having loans with no fixed duration are also very attractive allowing you to hodl your crypto
        while having USD to spend.
      </>
    ),
  },
  {
    id: 6,
    link: 'https://twitter.com/gokuafrica/status/1421938014897410048?s=21',
    author: {
      name: '@Gokuafrika',
      avatar: gokuafrica,
      avatarAlt: 'Crypto loans review 6',
    },
    image: twitter,
    title: <>Friendly loan terms: choose when to make payments yourself</>,
    text: (
      <>
        I am still riding the wave. Too early to make any profits off my loans. The cool thing is that by putting crypto
        as collateral and using your friendly loan terms, I can choose when to make payments to close/partially close
        loans. This is awesome as this frees me a lot!
      </>
    ),
  },
]


